export const POST_REPLY_DRAFT = {
  ADD_SOURCES: 'Add Sources',
  ANALYZE: 'Analyze',
  ANALYZE_AND_PUBLISH: 'Analyze & Publish',
  ANALYZING: 'Analyzing...',
  CANCEL: 'Cancel',
  CARD_EDITED_POST_TITLE: 'Changes',
  CLOSE_MODAL: 'Close',
  CREATE_DRAFT: 'Create Draft',
  DELETE_POST_REPLY_DRAFT: 'Delete',
  EDIT_POST_REPLY_DRAFT: 'Edit Reply Draft',
  EDIT_DRAFT: 'Edit Draft',
  PUBLISH_POST_REPLY_DRAFT: 'Publish',
  SAVE_DRAFT: 'Save Post',
  DONE_EDITING: 'Done Editing',
  SAVE_CHANGES: 'Save Changes',
  SHOW_LAST_ANALYSIS: 'Show Last Analysis',
  EDITED_MODAL: {
    TEXT_ADDED: 'Text Added',
    TEXT_REMOVED: 'Text Removed',
  },
  ANALYSIS_DIALOG: {
    STORY_ANALYSIS_RESULTS: 'Story Analysis Results',
    OVERALL_SCORE: 'Overall Score:',
    SENTIMENT_ANALYSIS: 'Sentiment Analysis',
    SAVE_ANALYSIS_AND_PUBLISH: 'Save Analysis and Publish',
    SAVE_ANALYSIS: 'Save Analysis',
  },
  ADD_SOURCES_DIALOG: {
    TITLE: 'Article Sources for AI Analysis',
    MAX_SOURCES: 5,
    MESSAGE:
      'You can enter up to five sources: news or social media, these will be used as part of the analysis.',
    ADD: 'Add Source(s)',
    CLOSE: 'Close',
    PLACEHOLDER: 'Source...',
    ERROR: {
      INVALID_URL: 'Enter a valid http(s) URL',
    },
  },
  LINK: {
    CONTINUE_EDITING: 'Continue editing your draft reply to this post',
    POST_YOU_ARE_REPLYING_TO: "Post you're replying to: ",
  },
};

/**
 * Maximum file size in bytes (3 MB) for draft images
 */
export const MAX_FILE_SIZE = 3 * 1024 * 1024; // 3MB

/**
 * Allowed image types for draft images
 */
export const ALLOWED_IMAGE_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/gif',
  'image/webp',
];
